import { Illustrations } from "@/illustrations";
import { Box, Button, Divider, Flex, Image, Input, Menu, MenuButton, MenuList, Stack, Text } from "@chakra-ui/react";
import { Icon, MenuItem } from "@pufflig/prompt-studio-ui";
import { Suspense } from "react";

interface CreatePromptbookFormProps {
  templateName: string;
  templateDescription: string;
  templateImageUrl?: string;
  workspaces: { workspace_id: string; name: string }[];
  selectedWorkspace: string | null;
  promptbookName: string;
  onSelectWorkspace: (workspaceId: string) => void;
  onRenamePromptbook: (name: string) => void;
}

export const CreatePromptbookForm = (props: CreatePromptbookFormProps) => {
  const {
    promptbookName,
    selectedWorkspace,
    templateName,
    templateDescription,
    templateImageUrl,
    workspaces,
    onRenamePromptbook,
    onSelectWorkspace,
  } = props;

  const selectedWorkspaceName = workspaces?.find((workspace) => workspace.workspace_id === selectedWorkspace)?.name;

  return (
    <Flex direction={["column", "column", "row"]}>
      <Stack gap="spacing-lg" justifyContent="space-between" height="100%" paddingBottom="spacing-xxl">
        <Box>
          <Suspense fallback={null}>
            {templateImageUrl ? (
              <Image
                bg="background.secondary"
                alt-text={templateName}
                objectFit="cover"
                height="24rem"
                width="24rem"
                borderRadius="radius-lg"
                src={templateImageUrl || ""}
              />
            ) : (
              <Illustrations.IdeaBook height="18rem" width="18rem" />
            )}
          </Suspense>
        </Box>
        <Stack gap="spacing-xxs">
          <Text textStyle="label/L/medium">{templateName}</Text>
          <Text textStyle="label/S/regular" color="foreground.secondary">
            {templateDescription}
          </Text>
        </Stack>
      </Stack>
      <Box flex="0 1" mx="spacing-lg">
        <Divider orientation="vertical" />
      </Box>
      <Stack flex="1" minWidth="18rem" gap="spacing-lg">
        <Stack>
          <Text textStyle="label/M/medium" color="foreground.secondary">
            Name your Promptbook
          </Text>
          <Input
            placeholder="Untitled Promptbook"
            value={promptbookName}
            onBlur={(e) => {
              if (!e.target.value) {
                onRenamePromptbook("Untitled Promptbook");
              }
            }}
            onChange={(e) => {
              onRenamePromptbook(e.target.value);
            }}
          />
        </Stack>
        <Stack>
          <Text textStyle="label/M/medium" color="foreground.secondary">
            Choose workspace
          </Text>
          <Menu>
            <MenuButton
              textAlign="left"
              fontWeight={"normal"}
              as={Button}
              leftIcon={<Icon name="folder-2" />}
              rightIcon={<Icon name="arrow-down-1" />}
            >
              {selectedWorkspaceName || "Select..."}
            </MenuButton>
            <MenuList>
              {workspaces?.map((workspace) => (
                <MenuItem
                  key={workspace.workspace_id}
                  primaryLabel={workspace.name}
                  leftIcon={<Icon name="folder-2" />}
                  rightIcon={selectedWorkspace === workspace.workspace_id ? <Icon name="check" /> : null}
                  onClick={() => {
                    onSelectWorkspace(workspace.workspace_id);
                  }}
                />
              ))}
            </MenuList>
          </Menu>
        </Stack>
      </Stack>
    </Flex>
  );
};
